import { createMuiTheme } from "@material-ui/core/styles";
const lightTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#273B73",
      contrastText: "#fff",
      light: "#E9F3FF",
    },
    secondary: {
      main: "#29678D",
      contrastText: "#fff",
      light: "#FFF3DF",
      dark: "#EFAA71",
      mainGradient: "linear-gradient(to right, #29678D, #29678D)",
    },
  },
  typography: {
    fontFamily: `'Poppins', sans-serif`,
    button: {
      textTransform: "none",
      fontWeight: 400,
    },
    caption: {
      fontFamily: `'Poppins', sans-serif`, // Change a specific variant
    },
  },
  props: {
    MuiButton: {
      disableElevation: true,
    },
  },
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: 12,
        fontWeight: 400,
      },
    },
  },
});

export default lightTheme;
